import {
  Component, Inject, Injector, forwardRef, ElementRef, OnInit,
  Optional,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { OSharedModule } from '../../../shared';
import { OFormComponent } from '../../form/o-form.component';
import {
  OTextInputModule, OTextInputComponent, DEFAULT_INPUTS_O_TEXT_INPUT,
  DEFAULT_OUTPUTS_O_TEXT_INPUT
} from '../text-input/o-text-input.component';
import { OValidators } from '../../../validators/o-validators';

export const DEFAULT_INPUTS_O_EMAIL_INPUT = [
  ...DEFAULT_INPUTS_O_TEXT_INPUT
];

export const DEFAULT_OUTPUTS_O_EMAIL_INPUT = [
  ...DEFAULT_OUTPUTS_O_TEXT_INPUT
];


export class OEmailInputComponent extends OTextInputComponent implements OnInit {

  public static DEFAULT_INPUTS_O_EMAIL_INPUT = DEFAULT_INPUTS_O_EMAIL_INPUT;
  public static DEFAULT_OUTPUTS_O_EMAIL_INPUT = DEFAULT_OUTPUTS_O_EMAIL_INPUT;

  constructor(
      form: OFormComponent,
    elRef: ElementRef,
    injector: Injector) {
    super(form, elRef, injector);
  }

  resolveValidators(): ValidatorFn[] {
    let validators: ValidatorFn[] = super.resolveValidators();
    //Inject email validator
    validators.push(OValidators.emailValidator);
    return validators;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-email-input',
  template: `
    <div fxLayout="row" fxLayoutAlign="space-between center" [formGroup]="getFormGroup()" [mdTooltip]="tooltip" [mdTooltipPosition]="tooltipPosition"
        [mdTooltipShowDelay]="tooltipShowDelay">
        <md-form-field #innerInputContainer fxFlexFill>
            <input mdInput type="email" [attr.id]="getAttribute()" [formControlName]="getAttribute()" [placeholder]="placeHolder"
                [ngModel]="getValue()" (ngModelChange)="innerOnChange($event)" (focus)="innerOnFocus($event)" (blur)="innerOnBlur($event)"
                [readonly]="isReadOnly">
            <md-icon mdSuffix [class.mat-disabled]="isDisabled">mail_outline</md-icon>
            <md-error *ngIf="hasError('required')">{{ 'FORM_VALIDATION.REQUIRED' | oTranslate }}</md-error>
            <md-error *ngIf="hasError('minlength')">{{ 'FORM_VALIDATION.MIN_LENGTH' | oTranslate }}: {{ getErrorValue('minlength', 'requiredLength') }}</md-error>
            <md-error *ngIf="hasError('maxlength')">{{ 'FORM_VALIDATION.MAX_LENGTH' | oTranslate }}: {{ getErrorValue('maxlength', 'requiredLength') }}</md-error>
            <md-error *ngIf="hasError('invalidEmailAddress')">{{ 'FORM_VALIDATION.EMAIL_FORMAT' | oTranslate }}</md-error>
        </md-form-field>

    </div>
  `,
  styles: [`

  `],
  inputs: [
    ...DEFAULT_INPUTS_O_EMAIL_INPUT
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_EMAIL_INPUT
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
}


export class OEmailInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OEmailInputComponent],
  imports: [OSharedModule, CommonModule, OTextInputModule],
  exports: [OEmailInputComponent, OTextInputModule],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
